import { render, staticRenderFns } from "./MinisiteButton.vue?vue&type=template&id=0bbc9b20&"
import script from "./MinisiteButton.vue?vue&type=script&lang=js&"
export * from "./MinisiteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbc9b20')) {
      api.createRecord('0bbc9b20', component.options)
    } else {
      api.reload('0bbc9b20', component.options)
    }
    module.hot.accept("./MinisiteButton.vue?vue&type=template&id=0bbc9b20&", function () {
      api.rerender('0bbc9b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MinisiteButton.vue"
export default component.exports